import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { CustomHighlightInput } from './custom-highlight-input'
import * as css from './styles'
import { t } from '@lingui/core/macro'

interface Props {
  delimiter: string
  position: string
  shouldRender: boolean
}

/**
 * Preview component for the Split-Extract functionality. This component works by creating an
 * ilusion of an Input with a highlighted component inside of it. When the Input has a value,
 * the text becomes transparent, and a <div> (InputHighlightedValue) is rendered right 'behind' of it,
 * giving the idea that the Input in rendering the markup.
 */
export function SplitPreview({ delimiter, position, shouldRender }: Props) {
  if (!shouldRender) return null
  return (
    <Box mt={2}>
      <Paper
        elevation={0}
        style={{
          background: 'rgb(244,244,244)',
          padding: 25,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <css.PreviewDiv>
          <Typography
            variant="subtitle1"
            style={{
              alignSelf: 'center',
            }}
            mb={1}
          >
            {t`Preview`}
          </Typography>
          <Tooltip title={t`Preview which value will be extracted`}>
            <css.CustomInfoIcon />
          </Tooltip>
        </css.PreviewDiv>
        <CustomHighlightInput delimiter={delimiter} position={position} />
      </Paper>
    </Box>
  )
}
